<!-- 提交大使馆 -->
<template>
  <div>
    <!-- 645px @opened="getInfo" -->
    <el-dialog title="" :close-on-click-modal="false" center :visible.sync="visible" :width="width" @open="getorgbalanceFun" :before-close="handleClose" class="common-dialog-class">
      <div class="dialog-member-title">
        <div class="dialog-member-name">快付支付</div>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="dialog-contenter">
        <div class="card-desc">
          <div>
            当前账户剩余<span class="themeColor">{{ autoPayPrice }}</span>元
          </div>
          <!-- <div class="recharge" @click="goPay">前往充值</div> -->
        </div>
        <div class="card-box">
          <div class="card-item" :class="{ active: type == 3 }" @click="chengeType(3)">
            <div class="card-item-left">
              <img src="@/assets/images/order/tickets.png" />
            </div>
            <div class="card-item-right">
              <div class="item-right-name">快付自动化支付</div>
              <div class="item-right-desc">平台自动付</div>
              <div class="item-right-ticket">
                <span>{{ info.visaFee }}</span>{{ info.exchageRateName }} = {{ transformPrice }}元
              </div>
              
            </div>
            <div v-if="type == 3" class="active-check">
              <i class="el-icon-check" />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button size="small" type="primary" class="submit-but" :disabled="false" @click="confirm">立即支付（<span>{{ transformPrice }}元</span>）</el-button>
        <el-button v-if="isResult && price > ticketsBalance" @click="rechargeShow = true" size="small" type="text">前往充值<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        <!-- <el-button v-if="isResult && price > ticketsBalance" @click="rechargeShow = true" size="small" type="text">前往充值<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
      </div>
    </el-dialog>
    <!-- <recharge :visible="rechargeShow" :orderId="orderId" @close="rechargeShow = false" @success="getorgbalanceFun"></recharge> -->
     <ticketsRecharge :visible='rechargeShow' :orderId="orderId" @close="rechargeShow = false" @success="getorgbalanceFun"></ticketsRecharge>
  </div>
</template>

<script>
import { getsystemvisa, getorgbalance } from "@/api/orderCenter";
import { getLocalStorage, setLocalStorage } from "@/utils/auth";
// import recharge from "./recharge";
import { EventBus } from '@/utils/eventBus.js';
import ticketsRecharge from '@/views/orderCenter/electron/components/recharge.vue';
import { getorgfastpaytotaldata,kmpayvisafee } from '@/api/finance.js'
export default {
  name: "SubmitApplication",
  components: {
    ticketsRecharge,
  },
  data() {
    return {
      type: 2,
      info: {
        countryId: "",
        name: "德国预约",
        isPackage: false, //是否支持打包提交
        isTickets: false, //是否支持点券提交
        packPrice: 750.0, //打包价
        tickets: 750.0, //普通支付,消耗点券
        typeDesc: "德国预约",
      },
      rechargeShow: false,
      ticketsBalance: "", //点券余额
      width: "900px", //宽度
      isResult: false,
      payData:{}
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String | Number,
      default: "",
    },
    orderId: {
      type: String | Number,
      default: "",
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
    length: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    price() {
      let price = 0;
      if (this.isBatch) {
        if(this.type == 2) {
          price = this.length * this.info.packPrice;
        }
        if(this.type == 1) {
          price = this.length * this.info.tickets;
        }
        if(this.type == 3) {
          price = this.length * this.info.tickets;
        }
      } else {
        if(this.type == 2) {
          price = this.info.packPrice;
        }
        if(this.type == 1) {
          price = this.info.tickets;
        }
        if(this.type == 3) {
          price = this.info.tickets;
        }
      }
      return price;
    },
    transformPrice() {
      return (this.info.visaFee * this.info.rate).toFixed(2);
    },
    autoPayPrice(){
      if(this.payData) {
        if(this.payData.incomg && this.payData.outcome) {
          return (this.payData.incomg - this.payData.outcome).toFixed(2);
        }
        return 0
      }
      return 0;
    }
  },
  created(){
    EventBus.$on('refreshOrgBalance', () => {
      this.getorgbalanceFun()
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.getInfo();
    });
  },
  methods: {
    goPay(){
      this.$router.push({
        path: "/settings"
      });
    },
    getPayData() {
      getorgfastpaytotaldata().then((res) => {
        if (res.code == 1) {
          this.payData = res.data;
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
    getInfo() {
      if (!this.orderId) return
      getsystemvisa({ orderId: this.orderId }).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          
          this.type =
            (this.info.isPackage && this.info.isTickets) || this.info.isPackage
              ? 2
              : 1;

          // 根据不同条件设置宽度
          const { isPackage, isTickets, isKMPay } = this.info;
          
          // 计算为真的条件数量
          const trueCount = [isPackage, isTickets, isKMPay].filter(Boolean).length;
          console.log(trueCount)
          // 根据条件数量设置宽度
          if (trueCount === 3) {
            this.width = '900px';
          } else if (trueCount === 2) {
            this.width = '645px';
          } else if (trueCount === 1) {
            this.width = '497px';
          }
          
          // 默认选中上一次提交方式  1：普通支付 2：打包支付
          if (
            getLocalStorage("submit_method") &&
            getLocalStorage("submit_method").countryId == this.info.countryId
          ) {
            this.type = getLocalStorage("submit_method").type;
          }
        }
      });
    },
    // 获取点券余额
    getorgbalanceFun() {
      getorgbalance().then((res) => {
        if (res.code == 1) {
          // SET_TICKETINGVALUE
          this.isResult = true;
          this.ticketsBalance = res.data;
          this.$store.commit("SET_TICKETSBALANCE", res.data);
        }
      });
    },
    chengeType(val) {
      //1：普通支付 2：打包支付
      this.type = val;
      setLocalStorage("submit_method", {
        countryId: this.info.countryId,
        type: this.type,
      });
    },
    confirm() {
      if (this.type) {
        // this.isBatch
        //   ? this.$emit("confirmBatch", this.type)
        //   : this.$emit("confirm", this.type, this.isBatch);
        kmpayvisafee({orderApplicantId:this.userId}).then(res=>{
          if(res.code == 1) {
            this.handleClose();
            this.$message.success("支付成功");
            this.$emit("confirm")
          }
        })
      } else {
        this.$message.error("请选择提交方式");
      }
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.getPayData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$themeColor: #3888e9;
::v-deep .common-dialog-class {
  background: none !important;
  border-radius: 12px;

  .el-dialog {
    background: none;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    // width: 761px;

    // height: 285px;
    background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
    border-radius: 12px;
    box-sizing: border-box;
    overflow: hidden;
  }
}
.common-dialog-foot-class {
  //width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;

  .pageck-btn {
    width: 145px;
    margin: 0 16px;
  }
}
.common-dialog-class {
  color: #333333;
  .dialog-contenter {
    margin-top: 12px;
    .themeColor {
      color: $themeColor;
    }
    .card-desc {
      display: inline-flex;
      .recharge {
        margin-left: 25px;
        color: $themeColor;
        cursor: pointer;
      }
    }
    .card-box {
      margin-top: 40px;
      display: flex;
      justify-content: space-around;
      .card-item + .card-item {
        margin-left: 20px;
      }
      .card-item {
        width: 285px;
        height: 130px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(95, 159, 237, 0.3);
        border-radius: 8px 8px 8px 8px;
        border: 2px solid transparent;
        transition: transform 0.3s;

        display: flex;
        align-items: center;
        //space-around;
        justify-content: space-around;
        position: relative;
        color: $themeColor;
        .card-item-left {
          img {
            width: 90px;
            height: 90px;
          }
        }
        .card-item-right {
          padding: 20px 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: calc(100% - 40px);
          .item-right-name {
            font-size: 20px;
          }
          .item-right-desc {
            font-size: 12px;
          }
          .item-right-ticket {
            font-size: 14px;
            span {
              color: #f8912c;
            }
          }
        }
      }
      .active {
        border: 2px solid $themeColor;
        overflow: hidden;
        .active-check {
          position: absolute;
          bottom: 0;
          right: 0;

          .el-icon-check {
            font-size: 24px;
            // margin-top: 12px;
            transform: rotate(0deg);
            color: #fff;
          }
        }
        .active-check::before {
          content: "";
          position: absolute;
          bottom: 0;
          right: 0;
          border-top: 45px solid transparent;
          border-right: 45px solid $themeColor;
        }
        .active-check::after {
          content: "";
          position: absolute;
          bottom: 0;
          right: 0;
          border-top: 45px solid transparent;
          border-right: 45px solid white;
          margin-right: -45px;
          margin-bottom: -45px;
        }
      }
    }
  }
  .dialog-footer {
    width: 100%;
    margin-top: 25px;
    justify-content: center;
    display: inline-flex;
    .submit-but {
      width: 230px;
      height: 46px;
      border-radius: 4px 4px 4px 4px;
    }
    .el-button--primary {
      background-color: $themeColor;
    }
    .el-button--primary.is-disabled {
      background: #cccccc !important;
      border-color: #cccccc !important;
    }
  }
}
</style>
